<template>
  <div class="container">
    <div :class="{'coupon-value-label':true,'home-style':forHomePage,'shop-home-style':forShopHomePage}" :style='{color:textColor}'>
      <span class="symbol" v-if="(couponType==='FIXED_CASH_COUPON' || couponType ==='REBATE_COUPON') && yuanSymbol">￥</span>
      <template v-if="couponType==='REALITY_GIFT_COUPON'">
        <div class="gift-wrap">
          <div class="gift-label">赠品</div>
          <div class="gift-threshold">满{{couponData && couponData.giftRule.length && couponData.giftRule[0].amount}}元可用</div>
          <div class="gift-coupon-name" v-if="forHomePage && !forShopHomePage">礼品券</div>
        </div>
      </template>
      <template v-else>
        <span class="integer" :style="{fontSize:fontSize,lineHeight: `calc(${fontSize}*0.9)`}">{{couponDisplayValue | formatPriceInt}}</span>
        <span class="float" v-if="withFloat && bigFloat" :style="{fontSize:fontSize,lineHeight: `calc(${fontSize}*0.9)`, fontWeight: 'bold'}">{{couponDisplayValue | formatPriceFloat}}</span>
        <span class="float" v-else-if="withFloat" :style="{fontSize: `calc(${fontSize}*0.5)`}">{{couponDisplayValue | formatPriceFloat}}</span>
        <span class="sales" :style="{fontSize: `calc(${fontSize}*0.5)`}" v-if="couponType==='DISCOUNT_COUPON'">折</span>
        <span class="yuan" :style="{fontSize: `calc(${fontSize}*0.5)`}" v-if="(couponType==='FIXED_CASH_COUPON' || couponType ==='REBATE_COUPON') && !yuanSymbol">元</span>
      </template>
    </div>
  </div>
</template>
<script>
// 券类型
// FIXED_CASH_COUPON：定额满减券
// REBATE_COUPON：满减券
// DISCOUNT_COUPON：折扣券
// EQUITY_COUPON：权益券
// GIFT_COUPON：礼品券
export default {
  name: 'couponValueLabel',
  props: {
    couponData: {
      type: Object,
      default: () => {}
    },
    couponValue: {
      type: String,
      default: '0'
    },
    couponType: {
      type: String,
      default: 'FIXED_CASH_COUPON'
    },
    yuanSymbol: {
      type: Boolean,
      default: true,
    },  
    bigFloat: {
      type: Boolean,
      default: false,
    },
    forHomePage: {
      type: Boolean,
      default: false
    },
    forShopHomePage: {
      type: Boolean,
      default: false
    },
    maxFontSize: {
      type: String,
      default: '0.64'
    },
    textColor: {
      type: String,
      default: '#ED2856'
    }
  },
  mounted() {
    console.log(this.couponData);
  },
  computed: {
    fontSize() {
      if (this.forHomePage) {
        if (String(this.couponDisplayValue).length < 6) {
          return '0.40rem'
        } else if (String(this.couponDisplayValue).length === 6) {
          return '0.38rem'
        } else if (String(this.couponDisplayValue).length > 6) {
          return '0.32rem'
        }
        return this.maxFontSize + 'rem'
      }
      
      const targ = this.bigFloat ? (this.withFloat ? 6 : 9) : 6

      if (String(this.couponDisplayValue).length < targ) {
        return this.maxFontSize + 'rem'
      } else if (String(this.couponDisplayValue).length === targ) {
        return 0.875 * this.maxFontSize + 'rem'
      } else if (String(this.couponDisplayValue).length > targ) {
        return 0.68 * this.maxFontSize + 'rem'
      }
      return this.maxFontSize + 'rem';
    },
    withFloat() {
      console.log('couponDisplayValue',this.couponDisplayValue);
      const arr = this.couponDisplayValue?.split('.')
      if (arr && arr.length > 1 && arr[1] !== '00' && arr[1] !== '0') {
        return true
      }
      return false
    },
    couponDisplayValue() {
      return this.couponType === 'DISCOUNT_COUPON' ? String(Number(this.couponValue) / 10) : this.couponValue
    }
  }
}
</script>

<style lang="scss" scoped>
  .container{
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    .coupon-value-label{
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: center;
      width:1.72rem;
      // font-family: PingFangSC, PingFangSC-Semibold;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      // color:#ED2856;
      .symbol{
        // margin-top: .16rem;
        font-size: 0.32rem;
        font-weight: bold;
      }
      .integer{
        font-size: 0.64rem;
        font-weight: bold;
        letter-spacing: -0.2px;
      }
      .float{
        // margin-top: .24rem;
        font-size: 0.24rem;
        // font-weight: bold;
      }
      .sales{
        // margin-top: .24rem;
        font-size: 0.24rem;
        font-weight: bold;
        margin-left: 2px;
      }
      .yuan {
        font-size: 0.24rem;
        font-weight: bold;
        margin-left: 2px;
      }
      .gift-wrap {
        padding-top: 5px;
        text-align: center;
        .gift-label {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 5px;
        }
        .gift-threshold {
          font-size: 12px;
        }
      }
    }
    .home-style {
      color:#FF500E;
      justify-content: flex-start;
      .symbol{
        font-size: 0.28rem;
        font-weight: bold;
      }
      .integer{
        font-size: 0.40rem;
        font-weight: bold;
      }
      .float{
        margin-top: .24rem;
        font-size: 0.24rem;
        font-weight: bold;
      }
      .sales{
        margin-top: .24rem;
        font-size: 0.24rem;
        font-weight: bold;
      }
      .gift-wrap {
        padding-top: 2px;
        text-align: initial;
        .gift-label {
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 0px;
        }
        .gift-threshold {
          font-size: 12px;
          margin-bottom: 3px;
          font-family: PingFangSC;
        }
        .gift-coupon-name {
          font-size: 12px;
          transform: scale(0.9);
          transform-origin: 0% 0%;
          font-family: PingFangSC;
        }
      }
    }
    .shop-home-style {
      .gift-wrap {
        padding-top: 2px;
        text-align: initial;
        .gift-label {
          margin-bottom: 3px;
          margin-top: 1px;
        }
        .gift-threshold {
          margin-bottom: 0px;
        }
      }
    }
  }

</style>
